import React from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import HeaderMenu from "../../../../Components/HeaderMenu";

import SLA from "./SLA";
import MasterTemplate from "./MasterTemplate";
import Modules from "./Modules";
import OrgansationalMetric from "./OrgansationalMetric";
import ManagementInformation from "./ManagementInformation";

const useStyles = makeStyles((theme) => ({
  tabRoot: {
    "& .MuiTabs-flexContainer": {
      justifyContent: "flex-start",
    },
    "& .MuiTabs-indicator": {
      backgroundColor: "transparent",
    },
  },
  tabs: {
    // fontSize: "16px",
    // fontFamily: "Open Sans",
    color: "#1e1e1e",
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: "#ddd",
    backgroundColor: "rgba(7,127,131,.75)",
    borderTopLeftRadius: 5,
    borderTopRightRadius: 5,
    marginRight: 10,
    minWidth: 130,
    textTransform: "inherit",
    "&:hover,&.Mui-selected": {
      color: "#fff",
      backgroundColor: "rgba(7,127,131,1)",
      opacity: 1,
    },
  },
}));

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <Box
      mt={3}
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && children}
    </Box>
  );
}

export default function FullWidthTabs() {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);

  const tabArr = [
    "Master templates",
    "SLA",
    "Modules",
    "Organizational metric",
    "Management information",
  ];
  const tabPanelArr = [
    <MasterTemplate />,
    <SLA />,
    <Modules />,
    <OrgansationalMetric />,
    <ManagementInformation />,
  ];

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <>
      <HeaderMenu />
      <Grid
        style={{ marginLeft: "2rem" }}
        container
        direction="row"
        justify="flex-start"
        alignItems="center"
      >
        <Grid item xs={8}>
          <Box my={5}>
            <Tabs
              value={value}
              onChange={handleChange}
              classes={{ root: classes.tabRoot }}
            >
              {tabArr.map((option) => (
                <Tab classes={{ root: classes.tabs }} label={option} />
              ))}
            </Tabs>
            {tabPanelArr.map((option, index) => (
              <TabPanel value={value} index={index}>
                {option}
              </TabPanel>
            ))}
          </Box>
        </Grid>
      </Grid>
    </>
  );
}
